import React from "react"
import clsx from "clsx"
import { Box } from "@gluestack-ui/themed"

type MaxWidth = "xs" | "sm" | "md" | "lg" | "xl" | "full"

const maxWidthClassName: Record<MaxWidth, string> = {
  xs: "max-w-[480px]",
  sm: "max-w-screen-sm",
  md: "max-w-screen-md",
  lg: "max-w-screen-lg",
  xl: "max-w-screen-xl",
  full: "max-w-full",
}

export type GluestackContainerProps = {
  maxWidth?: MaxWidth
  padded?: boolean
  as?: React.ElementType
  className?: string
  children?: React.ReactNode
  style?: React.CSSProperties
} & Record<string, any>

/**
  * Themed container built on gluestack's Box, providing responsive max-widths
  * and consistent horizontal padding aligned with our Tailwind + gluestack tokens.
  */
export const GluestackContainer = React.forwardRef<any, GluestackContainerProps>(
  ({ maxWidth = "xl", padded = true, as = "div", className, children, ...rest }, ref) => {
    const resolvedMaxWidth = maxWidthClassName[maxWidth] ?? maxWidthClassName.xl

    return (
      <Box
        as={as as any}
        ref={ref}
        className={clsx(
          "w-full mx-auto",
          padded && "px-4 sm:px-6 md:px-8",
          resolvedMaxWidth,
          className,
        )}
        {...rest}
      >
        {children as any}
      </Box>
    )
  },
)

GluestackContainer.displayName = "GluestackContainer"
